import { useQuery } from '@tanstack/react-query'
import { getDepartments, getDocumentTypes, getMembers } from '../services/organizationApi'
import type { Department, DocumentType, OrgMember } from '../services/organizationApi'

/** List departments for an organization */
export function useDepartments(orgKoblinkId?: string) {
  return useQuery<Department[]>({
    queryKey: ['departments', orgKoblinkId],
    queryFn: () => getDepartments(orgKoblinkId!),
    enabled: !!orgKoblinkId,
    staleTime: 5 * 60_000,
  })
}

/** List document types for an organization */
export function useDocumentTypes(orgKoblinkId?: string) {
  return useQuery<DocumentType[]>({
    queryKey: ['documentTypes', orgKoblinkId],
    queryFn: () => getDocumentTypes(orgKoblinkId!),
    enabled: !!orgKoblinkId,
    staleTime: 5 * 60_000,
  })
}

/** List members of an organization */
export function useOrgMembers(orgKoblinkId?: string) {
  return useQuery<OrgMember[]>({
    queryKey: ['orgMembers', orgKoblinkId],
    queryFn: () => getMembers(orgKoblinkId!),
    enabled: !!orgKoblinkId,
    staleTime: 2 * 60_000,
  })
}
